import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import tournamentsSlice from '../reducers/tournaments.slice'

const persistConfig = {
  key: 'tournamentsSlice',
  storage,
}

export const persistedTournamentsReducer = persistReducer(persistConfig, tournamentsSlice)